var t = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.SECONDARY = "secondary", r))(t || {});
export {
  t as RocheUIDropdownAppearance
};
